import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-button-back2',
  templateUrl: './button-back2.component.html',
  styleUrls: ['./button-back2.component.less']
})
export class ButtonBack2Component implements OnInit {
  @Input() disabled = false;

  constructor() { }

  ngOnInit(): void {
  }

}
